export default __webpack_public_path__ + "static/media/inactive4.b424421d.svg";